<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="教师姓名">
                  <el-input  style="width: 177px;" v-model="queryForm.teacherName"></el-input>
              </el-form-item>
              <el-form-item label="教师专业">
                  <el-input  style="width: 177px;" v-model="queryForm.teacherMajor"></el-input>
              </el-form-item>
              <el-form-item label="教师类型">
<!--                  <el-input  v-model="queryForm.teacherType"></el-input>-->
                  <el-select
                      clearable
                      style="width: 177px"
                      v-model="queryForm.teacherType"
                      placeholder="请选择"
                      size="small"
                  >
                      <el-option
                          v-for="item in typeList"
                          :label="item.value"
                          :value="item.key"
                      > </el-option>
                  </el-select>
              </el-form-item>
              <el-form-item label="关联账号">
                  <GridSelectU style="width: 177px;" title="选择用户" labelName="userName"
                               labelValue="id" :value="queryForm.userId" :limit='1' size='small' placeholder='请选择用户'
                               @getValue="getSearchValueUser" :columns="USER_code" :searchs="USER_search" dataListUrl="/mpp/user/findList" entityBeanName="mppUser" queryEntityUrl="/mpp/user/get">
                  </GridSelectU>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getEduTeacherList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addEduTeacher"
        >新建</el-button>
        <el-button
          type="warning"
          plain
          size="small"
          icon="el-icon-edit"
          :disabled="multipleSelection.length != 1"
          @click="editEduTeacher(null)"
        >修改</el-button>
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteEduTeacher(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
<!--        <span-->
<!--          title="下载模板"-->
<!--          class="icon-box"-->
<!--          @click="importTemplate"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowDown />-->
<!--          </Icon>-->
<!--        </span>-->
<!--        <span-->
<!--          class="icon-box"-->
<!--          title="导入数据"-->
<!--          @click="isImport"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowExportUp24Regular />-->
<!--          </Icon>-->
<!--        </span>-->
<!--        <span-->
<!--          title="导出数据"-->
<!--          class="icon-box"-->
<!--          @click="exportEduTeacherList"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowDownload24Regular />-->
<!--          </Icon>-->
<!--        </span>-->
        <span
          class="icon-box"
          @click="refreshEduTeacherList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="eduTeacherList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="userId"
        label="用户"
        width="180"
      >
          <template slot-scope="scope">
              <div v-if="scope.row.user">
                  <div style="text-align: left">账号：{{ scope.row.user.userName }}</div>
                  <div style="text-align: left">手机：{{ scope.row.user.userMobile }}</div>
                  <div style="text-align: left">昵称：{{ scope.row.user.userNickname }}</div>
                  <div style="text-align: left">姓名：{{ scope.row.user.userRealname }}</div>
              </div>
              <div v-else>--</div>
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="teacherName"
        label="教师姓名"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="teacherPic"
        label="教师头像"
        width="180"
      >
          <template slot-scope="scop">
              <el-image
                  @click='updateSrcList(scop.row.teacherPic)'
                  style="width: 60px; height: 60px"
                  :src="scop.row.teacherPic"
                  :preview-src-list="srcList"
              > </el-image>
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="teacherProfile"
        label="教师简介"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="teacherMajor"
        label="教师专业"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="teacherType"
        label="教师类型"
        width="180"
      >
          <template scope="scope">
              <span>{{ typeList.find(e=>e.key == scope.row.teacherType).value }}</span>
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="sort"
        label="排序"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="createTime"
        label="创建时间"
        width="180"
      > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
            <div @click="checkEduTeacher(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
            <div @click="editEduTeacher(scop.row.id)">
              <Icon size="16">
                <Edit24Regular />
              </Icon>
              <span class="operation-label">修改</span>
            </div>
            <div @click="deleteEduTeacher(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="eduTeacherStates[eduTeacherState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="eduTeacher"
          ref="eduTeacherForm"
          :rules="rules"
          label-width="90px"
          :inline="true"
          size="small"
        >
          <el-form-item
            label="教师姓名"
            prop="teacherName"
          >
            <el-input
                style="width: 177px;"
              size="small"
              v-model="eduTeacher.teacherName"
              :disabled="eduTeacherState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="教师专业"
            prop="teacherMajor"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="eduTeacher.teacherMajor"
              :disabled="eduTeacherState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="教师类型"
            prop="teacherType"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="eduTeacher.teacherType"-->
<!--              :disabled="eduTeacherState == 'check'"-->
<!--            ></el-input>-->
              <el-select
                  clearable
                  style="width: 177px"
                  v-model="eduTeacher.teacherType"
                  :disabled="eduTeacherState == 'check'"
                  placeholder="请选择"
                  size="small"
              >
                  <el-option
                      v-for="item in typeList"
                      :label="item.value"
                      :value="item.key"
                  > </el-option>
              </el-select>
          </el-form-item>
          <el-form-item
            label="排序"
            prop="sort"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              style="width: 177px;"-->
<!--              v-model="eduTeacher.sort"-->
<!--              :disabled="eduTeacherState == 'check'"-->
<!--            ></el-input>-->
              <el-input-number
                  style="width: 177px"
                  :disabled="eduTeacherState == 'check'"
                  v-model="eduTeacher.sort"
                  size="small"
                  label=""
                  :min="1"
                  :max="100000"
                  :step="1"
                  :controls="true"
                  controls-position="both"
              >
              </el-input-number>
          </el-form-item>
            <el-form-item
                label="教师头像"
                prop="teacherPic"
            >
                <!--            <el-input-->
                <!--              size="small"-->
                <!--              style="width: 177px;"-->
                <!--              v-model="eduTeacher.teacherPic"-->
                <!--              :disabled="eduTeacherState == 'check'"-->
                <!--            ></el-input>-->
<!--                <el-upload-->
<!--                    action=""-->
<!--                    :disabled="eduTeacherState == 'check'"-->
<!--                    class="avatar-uploader"-->
<!--                    :show-file-list="false"-->
<!--                    :http-request="uploadAvatar"-->
<!--                    style="width: 177px"-->
<!--                >-->
<!--                    <img-->
<!--                        v-if="eduTeacher.teacherPic"-->
<!--                        :src="eduTeacher.teacherPic"-->
<!--                        class="avatar"-->
<!--                    />-->
<!--                    <i-->
<!--                        v-else-->
<!--                        class="el-icon-plus avatar-uploader-icon"-->
<!--                    ></i>-->
<!--                </el-upload>-->
                <div style="width: 177px;display: flex;align-items: center;">
                    <el-input v-model="eduTeacher.teacherPic" size="small" :disabled="eduTeacherState == 'check'"></el-input>
                    <el-button type="primary" :disabled="eduTeacherState == 'check'" size="small" style="margin-left: 2px;" @click="uploadImages()">上传图片
                        <el-upload action="" v-show="false" ref="uploads" class="avatar-uploader" :show-file-list="false"
                                   :http-request="uploadAvatar">
                            <el-button type="primary" size="small" class="as">上传</el-button>
                        </el-upload>
                    </el-button>
                </div>
            </el-form-item>
            <el-form-item
                label="关联账号"
                prop="userId"
            >
                <GridSelectU style="width: 177px;" title="选择用户" labelName="userName" :disabled="eduTeacherState == 'check'"
                             labelValue="id" :value="eduTeacher.userId" :limit='1' size='small' placeholder='请选择用户'
                             @getValue="getValueUser" :columns="USER_code" :searchs="USER_search" dataListUrl="/mpp/user/findList" entityBeanName="mppUser" queryEntityUrl="/mpp/user/get">
                </GridSelectU>
            </el-form-item>
            <el-form-item
                label="教师简介"
                prop="teacherProfile"
            >
<!--                <el-input-->
<!--                    size="small"-->
<!--                    style="width: 39vw;"-->
<!--                    v-model="eduTeacher.teacherProfile"-->
<!--                    :disabled="eduTeacherState == 'check'"-->
<!--                ></el-input>-->
                <div style="width: 39vw;">
                    <WangEditor style="width: 100%;" ref="contentEditor1" :disabled="eduTeacherState" v-model="eduTeacher.teacherProfile" />
                </div>
            </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="eduTeacherState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun, upload } from '@/utils/request.js';
import GridSelectU from '@/components/gridselect/index.vue';
import { USER, USER_SEARCH } from '@/utils/constant';
import WangEditor from '@/components/common/wangeditor.vue';

export default {
    components: {
        WangEditor,
        GridSelectU,
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetEduTeacherList();
                    this.getEduTeacherList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetEduTeacherList();
                    this.getEduTeacherList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     userId: '', //用户
                     teacherName: '', //教师姓名
                     teacherPic: '', //教师头像
                     teacherProfile: '', //教师简介
                     teacherMajor: '', //教师专业
                     teacherType: '', //教师类型 1初级讲师 2高级讲师 3特级讲师
                     sort: '', //排序
                },
                srcList: [''],
                USER_code: USER,
                USER_search: USER_SEARCH,
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                eduTeacherState: 'add',
                eduTeacherStates: {
                    add: '新建课程老师',
                    check: '查看课程老师',
                    edit: '修改课程老师'
                },

                multipleSelection: [],
                eduTeacherList: [],
                eduTeacher: {
                    id: '', //
                    userId: '', //用户
                    teacherName: '', //教师姓名
                    teacherPic: '', //教师头像
                    teacherProfile: '', //教师简介
                    teacherMajor: '', //教师专业
                    teacherType: '', //教师类型 1初级讲师 2高级讲师 3特级讲师
                    sort: '', //排序
                },
                btnLoading: false,

                rules: {
                    userId: [{ required: true, message: '用户不能为空', trigger: 'blur' }],
                    teacherName: [{ required: true, message: '教师姓名不能为空', trigger: 'blur' }],
                    teacherPic: [{ required: true, message: '教师头像不能为空', trigger: 'blur' }],
                    teacherProfile: [{ required: true, message: '教师简介不能为空', trigger: 'blur' }],
                    teacherMajor: [{ required: true, message: '教师专业不能为空', trigger: 'blur' }],
                    teacherType: [{ required: true, message: '教师类型 1初级讲师 2高级讲师 3特级讲师不能为空', trigger: 'blur' }],
                    sort: [{ required: true, message: '排序不能为空', trigger: 'blur' }],
                },
                typeList: []
            };
        },
        created() {
            this.getEduTeacherList();
            this.getTypeEnum();
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            updateSrcList(src){
                this.srcList[0] = src
            },
            uploadImages(){
                this.$refs.uploads.$el.querySelector(".as").click()
            },
            uploadAvatar(params) {
                console.log({ params });
                const file = params.file;
                let types = ['image/jpeg', 'image/png', 'image/jpg'];
                if (!types.includes(file.type)) {
                    this.$message({
                        message: '只能上传图片格式的文件，png.jpg或者jpeg',
                        type: 'error',
                        showClose: true,
                        duration: 2000
                    });
                    return;
                }
                const formData = new FormData();
                formData.append('file', file);
                console.log({ formData });
                upload(`/mpp/image/upload`, formData).then((res) => {
                    console.log({ res });
                    if (res.success) {
                        this.eduTeacher.teacherPic = res.url;
                    }
                });
            },
            getSearchValueUser(value) {
                this.queryForm.userId = value
            },
            getValueUser(value) {
                this.eduTeacher.userId = value
            },
            getTypeEnum() {
                get('/edu/utils/getEnum?enumType=teacher_type').then(res => {
                    if(res.success){
                        this.typeList = res.enumList
                    }
                })
            },
            resetEduTeacherList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.eduTeacherList = [];
            },
            resetDialog() {
                this.eduTeacherState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      userId: '', //用户
                      teacherName: '', //教师姓名
                      teacherPic: '', //教师头像
                      teacherProfile: '', //教师简介
                      teacherMajor: '', //教师专业
                      teacherType: '', //教师类型 1初级讲师 2高级讲师 3特级讲师
                      sort: '', //排序
                };
                this.$refs.contentEditor1.htmls = "";
                this.getEduTeacherList();
            },
            closeDialog() {
                this.showDialog = false
                this.eduTeacher = {
                      id: '', //
                      userId: '', //用户
                      teacherName: '', //教师姓名
                      teacherPic: '', //教师头像
                      teacherProfile: '', //教师简介
                      teacherMajor: '', //教师专业
                      teacherType: '', //教师类型 1初级讲师 2高级讲师 3特级讲师
                      sort: '', //排序
                };
                this.$refs.contentEditor1.htmls = "";
            },
            submitForm() {
                if (this.eduTeacherState == 'add') {
                    this.$refs.eduTeacherForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/edu/teacher/add`,{ ...this.eduTeacher }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetEduTeacherList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.eduTeacherState == 'edit') {
                    this.$refs.eduTeacherForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            delete this.eduTeacher.user
                            post(`/edu/teacher/edit`,{ ...this.eduTeacher }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetEduTeacherList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addEduTeacher() {
                this.showDialog = true;
                this.eduTeacherState = 'add';
            },
            checkEduTeacher(eduTeacherId) {
                console.log(eduTeacherId);
                this.currentEduTeacherId = eduTeacherId;

                this.getEduTeacherById();
                this.showDialog = true;
                this.eduTeacherState = 'check';
            },
            editEduTeacher(eduTeacherId) {
                console.log('eduTeacher', eduTeacherId);
                if (eduTeacherId) {
                    this.currentEduTeacherId = eduTeacherId;
                    this.getEduTeacherById();
                } else {
                    this.eduTeacher = { ...this.eduTeacher, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.eduTeacherState = 'edit';
            },
            deleteEduTeacher(eduTeacherId) {
                let ids = '';
                if (eduTeacherId) {
                    ids = eduTeacherId;
                } else {
                    ids = this.multipleSelection.map((eduTeacher) => eduTeacher.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/edu/teacher/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetEduTeacherList();
                                this.getEduTeacherList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshEduTeacherList() {
                this.resetEduTeacherList();
                this.getEduTeacherList();
            },
            getEduTeacherList(query = {}) {
                this.loading = true;
                get(`/edu/teacher/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.eduTeacherList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getEduTeacherById() {
                get(`/edu/teacher/get`,{ id: this.currentEduTeacherId }).then((res) =>{
                    if(res.success){
                      this.eduTeacher = { ...this.eduTeacher, ...res.eduTeacher };
                        this.$refs.contentEditor1.init(res.eduTeacher.teacherProfile)
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportEduTeacherList() {
                //this.btnLoading = true;
                exprotExcel(`/edu/teacher/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/edu/teacher/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/edu/teacher/importData`,formData);
              this.refreshEduTeacherList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getEduTeacherList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getEduTeacherList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
::v-deep .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 177px;
    height: 177px;
}
.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 177px;
    height: 177px;
    line-height: 177px;
    text-align: center;
}
.avatar {
    width: 177px;
    height: 177px;
    display: block;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>